import React from "react";
import { formatKeywordsWithCommas, handleTooltip, useTooltip } from "../Helpers/KeywordUtils";
import Tooltip from "../Helpers/Tooltip";

function WeaponsContainer({ isMeleeTable, weapons }) {
    const mainTitle = isMeleeTable ? "Melee Weapons" : "Ranged Weapons";
    const weaponSkillTitle = isMeleeTable ? "WS" : "BS";

    const {
        tooltipVisible,
        setTooltipVisible,
        tooltipContent,
        setTooltipContent,
        tooltipPosition,
        setTooltipPosition,
    } = useTooltip();

    const handleSpecialRuleClick = (event, rule) => {
        handleTooltip(event, rule, null, setTooltipContent, setTooltipPosition, setTooltipVisible, { isWeapon: true });
    };

    return (
        <div className="mt-4">
            <h2 className="font-bold  text-base">{mainTitle}</h2>
            {weapons ? (
                <div className="space-y-3">
                    {weapons.map((weapon, index) => {
                        const isMissingData = false;

                        return (
                            <details key={index} className="mt-2  rounded  bg-slate-100  group">
                                <summary className={`flex  items-center  gap-1  p-5  font-bold  list-none  ${isMissingData ? "text-red-700" : ""}`}>
                                    {weapon.WeaponName}
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-5  h-5  ml-auto  transition  group-open:rotate-180">
                                        <path fillRule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clipRule="evenodd" />
                                    </svg>
                                </summary>

                                <div className="px-5  pb-5">
                                    {weapon.SpecialRules && weapon.SpecialRules.length > 0 && (
                                        <div className="flex  flex-wrap  gap-2  -mt-3">
                                            {formatKeywordsWithCommas(weapon.SpecialRules, handleSpecialRuleClick)}
                                        </div>
                                    )}

                                    {isMissingData ? (
                                        <>
                                            <p className="text-red-700">
                                                Data not available
                                            </p>
                                        </>
                                    ) : (
                                        <>
                                            <table className="w-full  mt-2  border-collapse  border  border-slate-200  text-center">
                                                <thead>
                                                <tr>
                                                    <th className="px-2  py-1  border  border-slate-300  bg-slate-200">Range</th>
                                                    <th className="px-2  py-1  border  border-slate-300  bg-slate-200">A</th>
                                                    <th className="px-2  py-1  border  border-slate-300  bg-slate-200">{weaponSkillTitle}</th>
                                                    <th className="px-2  py-1  border  border-slate-300  bg-slate-200">S</th>
                                                    <th className="px-2  py-1  border  border-slate-300  bg-slate-200">AP</th>
                                                    <th className="px-2  py-1  border  border-slate-300  bg-slate-200">D</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr>
                                                    <td className="px-2  py-1  border  border-slate-200">{weapon.Range}</td>
                                                    <td className="px-2  py-1  border  border-slate-200">{weapon.A}</td>
                                                    <td className="px-2  py-1  border  border-slate-200">{weapon.WeaponSkill}</td>
                                                    <td className="px-2  py-1  border  border-slate-200">{weapon.S}</td>
                                                    <td className="px-2  py-1  border  border-slate-200">{weapon.AP}</td>
                                                    <td className="px-2  py-1  border  border-slate-200">{weapon.D}</td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </>
                                    )}
                                </div>
                            </details>
                        );
                    })}
                </div>
            ) : (
                <p>No {mainTitle.toLowerCase()} found.</p>
            )}
            <Tooltip
                visible={tooltipVisible}
                content={tooltipContent}
                position={tooltipPosition}
                onClick={() => setTooltipVisible(false)}
            />
        </div>
    );
}

export default WeaponsContainer;